namespace TabAurous.Production {
    export interface QualityInspectionValuesRow {
        TransInspectionId?: number;
        TransItemId?: number;
        Parameter?: string;
        ExpectedValue?: string;
        InspectedValue?: string;
        Min?: string;
        Max?: string;
        Remark?: string;
        Status?: boolean;
    }

    export namespace QualityInspectionValuesRow {
        export const idProperty = 'TransInspectionId';
        export const nameProperty = 'Parameter';
        export const localTextPrefix = 'Production.QualityInspectionValues';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            TransInspectionId = "TransInspectionId",
            TransItemId = "TransItemId",
            Parameter = "Parameter",
            ExpectedValue = "ExpectedValue",
            InspectedValue = "InspectedValue",
            Min = "Min",
            Max = "Max",
            Remark = "Remark",
            Status = "Status"
        }
    }
}
